<script setup lang="ts">
const modal = useModal();
const { t } = useI18n();
</script>

<template>
  <UModal
    :ui="{
      width: 'w-full sm:max-w-3xl',
      margin: 'm-0 sm:m-auto',
      rounded: 'rounded-none sm:rounded-lg',
      height: 'h-full sm:h-auto',
      background: 'bg-black',
    }"
  >
    <div class="relative flex h-full items-center justify-center sm:block">
      <UButton
        icon="i-heroicons-x-mark"
        variant="ghost"
        color="white"
        size="lg"
        :aria-label="t('videoModal.closeAriaLabel')"
        class="absolute right-2 top-2 z-10 sm:right-0 sm:-top-12"
        @click="modal.close()"
      />
      <div class="relative w-full overflow-hidden sm:rounded-lg pb-[63.75%]">
        <iframe
          src="https://www.loom.com/embed/964fbab9d9b74127bcbfc3ce9f274222"
          :title="t('videoModal.title')"
          class="absolute inset-0 size-full"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
        />
      </div>
    </div>
  </UModal>
</template>
